export const buildURL = (baseURL: string, params) => {
  let url = new URL(baseURL);
  for (let key in params) {
    if (params[key]) {
      url.searchParams.set(key, params[key]);
    }
  }
  return url.toString();
}
